import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';

import { getLoginMenuData } from 'constants/LoginMenu';

import { logOut } from 'store/user-actions';
import Cookies from 'js-cookie';
const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_COOKIE_CONSTANT}`
);
import classes from './UserOptions.module.css';

const UserOptions = props => {
  const { t } = useTranslation(['header']);
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state.userInfo);
  const dataAcademy = useSelector(state => state.academyInfo);

  const logoutUser = () => {
    dispatch(logOut());
  };

  const logoutUserTec = () => {
    document.cookie =
      'mayahiijwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mayahii.com;';
    window.location.href = `https://saml.mayahii.com/logout?jwt=${jwtCookie}&returnUrl=${encodeURIComponent(
      `${process.env.REACT_APP_API_PATH_MAYAHII}/${dataAcademy.data.shortName}`
    )}`;
  };

  return (
    <div>
      <MenuItem className={classes.userInfo}>
        <figure className={classes.userAvatar}>
          <img
            className={classes.img}
            src={
              userInfo.data.foto
                ? userInfo.data.foto
                : 'https://d1g6c01s9ssd7h.cloudfront.net/img/usuario12.png'
            }
            alt="userIcon"
          />
        </figure>
        <p className={classes.userName}>{userInfo.data.nombre}</p>
        <p className={classes.userEmail}>{userInfo.data.email}</p>
      </MenuItem>
      <Divider />
      {getLoginMenuData().map(item => (
        <MenuItem
          key={item.link}
          component="a"
          href={item.link}
          onClick={props.closeMenu}
        >
          {t(item.text)}
        </MenuItem>
      ))}
      <MenuItem
        onClick={
          dataAcademy.data.idAcademy === 1816 ||
          dataAcademy.data.idAcademy === 58 ||
          dataAcademy.data.idAcademy === 1153
            ? logoutUserTec
            : logoutUser
        }
      >
        {t('log_out')}
      </MenuItem>
    </div>
  );
};

UserOptions.propTypes = {
  // eslint-disable-next-line react/require-default-props
  closeMenu: PropTypes.function
};

export default UserOptions;
